<div class="dashboad-title">
  <div class="row">
    <button type="button" (click)="setSelectedOption('tot')" class="btn m-btn--pill btn-primary dashboard-title-nav-btn">
      {{name}}
      <!-- SSC -->
    </button>
  </div>
  <div class="row">
    <p class="header-item">{{headerTitle}}</p>
    <p class="sub-title">{{subTitle}}</p>
  </div>
</div>